<div class="sectionContainer paddedContent containerMargins">
  <div
    style="
      display: flex;
      align-items: center;
      gap: 40px;
      border-bottom: 1px solid #dddddd;
    "
  >
    <h2>External API Management</h2>
    <div
      style="display: flex; align-items: center; gap: 2px; margin-bottom: 20px"
    >
      <input
        type="checkbox"
        style="width: 20px; height: 20px"
        [(ngModel)]="merchantAPIInfoData.enabled"
        (change)="onEnabledChange(merchantAPIInfoData.enabled, false)"
      />
      <p>Enabled</p>
    </div>
  </div>
  @if (merchantAPIInfoData.enabled) {
    <div>
      <div style="border-bottom: 1px solid #dddddd">
        <div>
          <p style="font-weight: bold">Client ID:</p>
          <p>{{ merchantAPIInfoData.clientId }}</p>
        </div>
        <div>
          <p style="font-weight: bold">Client Key:</p>
          <p>{{ merchantAPIInfoData.clientKey }}</p>
        </div>
      </div>
      <br />
      <div [showLoadingSpinner]="loading">
        <table class="sectionContainer selectableTable">
          <tr>
            <th>Scope</th>
            <th>Enabled</th>
          </tr>
          @for (scope of merchantAPIInfoData.scopes; track scope) {
            <tr>
              <td>{{ scope.scope }}</td>
              <td>
                <input
                  type="checkbox"
                  style="width: 20px; height: 20px"
                  [(ngModel)]="scope.enabled"
                  (change)="onScopeChange(scope, false)"
                />
              </td>
            </tr>
          }
        </table>
      </div>
    </div>
  }
</div>

<div class="sectionContainer paddedContent containerMargins">
  <div
    style="
      display: flex;
      align-items: center;
      gap: 40px;
      border-bottom: 1px solid #dddddd;
    "
  >
    <h2>Sandbox External API Management</h2>
    <div
      style="display: flex; align-items: center; gap: 2px; margin-bottom: 20px"
    >
      <input
        type="checkbox"
        style="width: 20px; height: 20px"
        [(ngModel)]="merchantAPIInfoData.sandboxEnabled"
        (change)="onEnabledChange(merchantAPIInfoData.sandboxEnabled, true)"
      />
      <p>Enabled</p>
    </div>
  </div>
  @if (merchantAPIInfoData.sandboxEnabled) {
    <div>
      <div style="border-bottom: 1px solid #dddddd">
        <div>
          <p style="font-weight: bold">Client ID:</p>
          <p>{{ merchantAPIInfoData.sandboxClientId }}</p>
        </div>
        <div>
          <p style="font-weight: bold">Client Key:</p>
          <p>{{ merchantAPIInfoData.sandboxClientKey }}</p>
        </div>
      </div>
      <br />
      <div [showLoadingSpinner]="loading">
        <table class="sectionContainer selectableTable">
          <tr>
            <th>Scope</th>
            <th>Enabled</th>
          </tr>
          @for (scope of merchantAPIInfoData.sandboxScopes; track scope) {
            <tr>
              <td>{{ scope.scope }}</td>
              <td>
                <input
                  type="checkbox"
                  style="width: 20px; height: 20px"
                  [(ngModel)]="scope.enabled"
                  (change)="onScopeChange(scope, true)"
                />
              </td>
            </tr>
          }
        </table>
      </div>
    </div>
  }
</div>
